import { AppLayout } from "../../components/layout/Header";
import DeskDashboard from "../../components/desk/DeskDashboard";
import DeskPlatformBadge from "../../components/desk/DeskPlatformBadge";
import { payUrl, JOURNEY_LINK_PROPS } from "../../js/utils/siteLinks";
import { useAuth } from "../../js/hooks/useAuth";

export default function AgentDashboard() {
  const { session } = useAuth();

  return (
    <AppLayout variant="agent">
      <DeskDashboard
        heading="Agent Dashboard"
        heroClassName="agent-hero"
        badge={<DeskPlatformBadge />}
        actions={
          <p>
            <a className="ghost-btn" href={payUrl(session)} {...JOURNEY_LINK_PROPS}>
              Subscribe
            </a>
          </p>
        }
      />
    </AppLayout>
  );
}
